import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-card-barline-chart',
  imports: [ChartModule, Skeleton, CommonModule],
  templateUrl: './card-barline-chart.component.html',
  styleUrl: './card-barline-chart.component.css',
  standalone: true,
})
export class CardBarlineChartComponent implements OnChanges {
  @Input({ required: true }) isLoading: boolean = false;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) labels!: string[];
  @Input({ required: true }) lineChartTitle!: string;
  @Input({ required: true }) lineChartData!: number[];
  @Input({ required: true }) lineChartBorderColor!: string;
  @Input() lineChart2Title?: string;
  @Input() lineChart2Data?: number[];
  @Input() lineChart2BorderColor?: string;
  @Input({ required: true }) barChart1Title!: string;
  @Input({ required: true }) barChart1Data!: number[];
  @Input({ required: true }) barChart1BorderColor!: string;
  @Input({ required: true }) barChart1BackgroundColor!: string;
  @Input({ required: true }) barChart2Title!: string;
  @Input({ required: true }) barChart2Data!: number[];
  @Input({ required: true }) barChart2BorderColor!: string;
  @Input({ required: true }) barChart2BackgroundColor!: string;
  @Input() barChart3Title?: string;
  @Input() barChart3Data?: number[];
  @Input() barChart3BorderColor?: string;
  @Input() barChart3BackgroundColor?: string;

  data: any;
  options: any;

  ngOnChanges(changes: SimpleChanges): void {
    this.initChart();
  }

  initChart() {
    let datasets = [
      {
        type: 'line',
        label: this.lineChartTitle,
        borderColor: this.lineChartBorderColor,
        borderWidth: 2,
        fill: false,
        tension: 0.4,
        data: this.lineChartData,
        yAxisID: 'y1',
      },
      {
        type: 'bar',
        label: this.barChart1Title,
        backgroundColor: this.barChart1BackgroundColor,
        data: this.barChart1Data,
        borderColor: this.barChart1BorderColor,
        borderWidth: 2,
      },
      {
        type: 'bar',
        label: this.barChart2Title,
        backgroundColor: this.barChart2BackgroundColor,
        data: this.barChart2Data,
        borderColor: this.barChart2BorderColor,
        borderWidth: 2,
      },
    ];

    if (this.lineChart2Title) {
      datasets.push({
        type: 'line',
        label: this.lineChart2Title!,
        borderColor: this.lineChart2BorderColor!,
        borderWidth: 2,
        fill: false,
        tension: 0.4,
        data: this.lineChart2Data!,
        yAxisID: 'y2',
      });
    }

    if (this.barChart3Title) {
      datasets.push({
        type: 'bar',
        label: this.barChart3Title!,
        backgroundColor: this.barChart3BackgroundColor!,
        data: this.barChart3Data!,
        borderColor: this.barChart3BorderColor!,
        borderWidth: 2,
      });
    }

    this.data = {
      labels: this.labels,
      datasets: datasets,
    };

    this.options = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      scales: {
        y: {
          type: 'linear',
          display: true,
          position: 'left',
        },
        y1: {
          type: 'linear',
          display: true,
          position: 'right',
        },
      },
    };
  }
}
